module.exports = __webpack_public_path__ + "static/media/contatti_new.63b174ac.jpg";